import { render, staticRenderFns } from "./RelaunchPickl.vue?vue&type=template&id=06eef2b1&scoped=true&"
import script from "./RelaunchPickl.vue?vue&type=script&lang=js&"
export * from "./RelaunchPickl.vue?vue&type=script&lang=js&"
import style0 from "./RelaunchPickl.vue?vue&type=style&index=0&id=06eef2b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06eef2b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06eef2b1')) {
      api.createRecord('06eef2b1', component.options)
    } else {
      api.reload('06eef2b1', component.options)
    }
    module.hot.accept("./RelaunchPickl.vue?vue&type=template&id=06eef2b1&scoped=true&", function () {
      api.rerender('06eef2b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/RelaunchPickl.vue"
export default component.exports